import Target from "@/components/Target";
import cloudflareLoader from "@/lib/cloudflare-images";
import colourways from "@/lib/colourways";
import clsx from "clsx";
import Image from "next/legacy/image";
import Link from "next/link";

const Module = ({
  image,
  heading,
  text,
  href,
  colourway = "white",
  buttonLabel = "See more",
  imagePosition = "left",
  target = null,
  roundedCorners = true,
  gapless = false,
  aspectRatio = "16/11",
  headingSize = "lg",
  buttonSize = "lg",
  textPadding = false,
  divider = false,
}) => {
  const _Wrapper = (props) => {
    const { children } = props;

    if (!!target && !!target.element)
      return (
        <Target target={target} {...props}>
          {children}
        </Target>
      );

    if (!href) return <div {...props}>{children}</div>;

    return (
      (<Link href={href} {...props}>
        {children}
      </Link>)
    );
  };

  const moduleColourway = colourways(colourway);

  return (
    <div
      className={clsx("Module", "@container/module", {
        "bg-zinc-800": divider,
      })}
    >
      <div
        className={clsx("grid grid-cols-12", {
          "@3xl:gap-x-12": !gapless,
          "gap-y-[2px] @3xl:gap-x-[2px] @3xl:gap-y-0": divider,
        })}
      >
        <div
          className={clsx("col-span-12 @3xl/module:col-span-6", {
            "@3xl/module:order-1": imagePosition === "left",
            "@3xl/module:order-2": imagePosition === "right",
          })}
        >
          <_Wrapper
            className={clsx(
              "group relative isolate block transform overflow-hidden",
              {
                "aspect-16/11": aspectRatio === "16/11",
                "aspect-4/3 3xl:aspect-16/11": aspectRatio === "4/3",
                "rounded-2xl": roundedCorners,
              }
            )}
          >
            {!!image && (
              <Image
                src={image.url}
                alt={image.title}
                layout="fill"
                objectFit="cover"
                className={clsx("", {
                  "transition ease-out group-hover:scale-[1.025]": !!href,
                })}
                loader={cloudflareLoader}
              />
            )}
          </_Wrapper>
        </div>
        <div
          className={clsx(
            "col-span-12 flex items-center @3xl/module:col-span-6",
            [divider ? moduleColourway.bg : ""],
            {
              "@3xl/module:order-2 @3xl/module:pl-12": imagePosition === "left",
              "@3xl/module:order-1 @3xl/module:pr-12":
                imagePosition === "right",
              "px-6 lg:px-12": textPadding,
              "text-white": moduleColourway.useLightText,
              "text-zinc-800": !moduleColourway.useLightText,
            }
          )}
        >
          <div className={clsx("space-y-4 py-6")}>
            <h3
              className={clsx("max-w-3xl", {
                "heading-md--thin": headingSize === "md",
                "heading-lg--thin": headingSize === "lg",
              })}
            >
              <_Wrapper href={href}>{heading}</_Wrapper>
            </h3>
            <div
              className={clsx("body-text !max-w-xl")}
              dangerouslySetInnerHTML={{ __html: text }}
            ></div>
            {(!!href || !!target) && (
              <div>
                <_Wrapper className={clsx("button button-dark", {})}>
                  {buttonLabel}
                </_Wrapper>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Module;
